import { IntegrationProviderEnum } from 'constants-integrations';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use DependencyEnum from application-types instead.
 */
export enum DependencyEnum {
  channelIntegrations = 'channelIntegrations',
  isSuperUser = 'isSuperUser',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use DependencyType from application-types instead.
 */
export type DependencyType = {
  channelIntegrations?: IntegrationProviderEnum[];
  isSuperUser?: boolean;
};
